<script setup lang="ts">
import type {ResponseType} from "~/types/Task";
import {RoleEnum} from "~/types/User";
import UserAvatar from '~/components/custom-ui/UserAvatar.vue'
import type { UserOnline } from '~/types/Chat';

const props = defineProps({
    chat: {
        type: Object as PropType<ResponseType>,
        required: true,
    }
})

const emit = defineEmits(['selectChat'])

const userStore = useUserStore()
const route = useRoute()

const receiver = computed(() => {
    if(userStore.user?.user_role === RoleEnum.MASTER){
        return props.chat.task.owner
    } else if(userStore.user?.user_role === RoleEnum.CUSTOMER){
        return props.chat.portfolio?.user
    }
    return null
})

const {
    usersOnline
} = useSocket()

const isUserOnline = computed(() => {
    if(!usersOnline?.value || !receiver.value?.documentId) return false
    const user = usersOnline.value.find((user: UserOnline) => user.userId === receiver.value?.documentId)
    return user?.isOnline || false
})

const unreadMessages = computed(() => {
    if(userStore.currentRole === RoleEnum.MASTER){
        return props.chat.unread_messages_count
    } else if(userStore.currentRole === RoleEnum.CUSTOMER){
        return props.chat.customer_unread_messages_count
    }
    return 0
})

const isSelected = computed(() => {
    return route.name === 'office_chat' && route.params.id === props.chat.documentId
})

</script>

<template>
    <NuxtLink
        :to="{ name: 'office_chat', params: { id: chat.documentId } }"
            class="flex items-center cursor-pointer hover:bg-gray-100 px-2 py-2 rounded-md"
            :class="{
                    'border-b': isSelected,
                    'bg-gray-100': isSelected
                }">
        <template v-if="receiver">
            <UserAvatar 
                :name="receiver.username" 
                :src="receiver?.avatar?.url || receiver?.avatar?.formats?.small?.url" 
                size="xs" 
                show_online_mark                
                :is_online="isUserOnline" 
                class="mr-2" />
            <div class="chat_user_name">
                <p class="font-medium text-xs lg:text-sm">{{ receiver?.username }}</p>
                <p class="font-[400] text-xs text-gray-700">{{ chat.task.name }}</p>
            </div>
            <span class="rounded-full text-[10px] font-bold text-white bg-red-500 py-1/2 px-1 ml-auto flex items-center justify-center flex-shrink-0" v-if="unreadMessages">{{ unreadMessages }}</span>
        </template>
								
    </NuxtLink>
</template>

<style scoped lang="scss">

</style>